/**
 * Convert the content from data into an array of objects to be used in different components
 *
 * @param entry
 * @returns {*[]}
 */
export default function getExerciseMaterialData(entry, t) {
  const data = []
  const theme = process.env.NEXT_PUBLIC_THEME
  if (!entry) return null

  const content = entry?.exerciseContent?.[0]?.exerciseFigure?.[0] ? entry.exerciseContent[0].exerciseFigure[0] : entry

  // Balls
  if (content?.ballCount) {
    data.push({
      icon: 'ball',
      label: content.ballCount,
      tooltip: `${content.ballCount} ${
        content.ballCount > 1 ? t('MATERIALBLOCK__FOOTBALLS') : t('MATERIALBLOCK__FOOTBALL')
      }`
    })
  }

  // Pawn
  if (content?.coneCount) {
    data.push({
      icon: 'cone',
      label: content.coneCount,
      tooltip: `${content.coneCount} ${content.coneCount > 1 ? t('MATERIALBLOCK__CONES') : t('MATERIALBLOCK__CONE')}`
    })
  }

  // Goals
  if (content?.goalIndoorCount) {
    data.push({
      icon: 'goal-indoor',
      label: content.goalIndoorCount,
      tooltip: `${content.goalIndoorCount} ${t('MATERIALBLOCK__FUTSAL')} ${
        content.goalIndoorCount > 1 ? t('MATERIALBLOCK__GOALS') : t('MATERIALBLOCK__GOAL')
      } ${t('MATERIALBLOCK__GOALSIZE_INDOOR')}`
    })
  }
  if (content?.goalSmallCount) {
    data.push({
      icon: 'goal-small',
      label: content.goalSmallCount,
      tooltip: `${content.goalSmallCount} ${t('MATERIALBLOCK__MINI')} ${
        content.goalSmallCount > 1 ? t('MATERIALBLOCK__GOALS') : t('MATERIALBLOCK__GOAL')
      } ${t('MATERIALBLOCK__GOALSIZE_SMALL')}`
    })
  }
  if (content?.goalMediumCount) {
    data.push({
      icon: 'goal-medium',
      label: content.goalMediumCount,
      tooltip: `${content.goalMediumCount} ${t('MATERIALBLOCK__PUPILS')} ${
        content.goalMediumCount > 1 ? t('MATERIALBLOCK__GOALS') : t('MATERIALBLOCK__GOAL')
      } ${t('MATERIALBLOCK__GOALSIZE_MEDIUM')}`
    })
  }
  if (content?.goalLargeCount) {
    data.push({
      icon: 'goal-large',
      label: content.goalLargeCount,
      tooltip: `${content.goalLargeCount} ${t('MATERIALBLOCK__SENIOR')} ${
        content.goalLargeCount > 1 ? t('MATERIALBLOCK__GOALS') : t('MATERIALBLOCK__GOAL')
      } ${t('MATERIALBLOCK__GOALSIZE_LARGE')}`
    })
  }

  // Louis school materials
  if (content?.benchCount) {
    data.push({
      icon: 'bench',
      label: content.benchCount,
      tooltip: `${content.benchCount} ${
        content.benchCount > 1 ? t('MATERIALBLOCK__BENCHES') : t('MATERIALBLOCK__BENCH')
      }`
    })
  }
  if (content?.vaultingBoxCount) {
    data.push({
      icon: 'vaulting-box',
      label: content.vaultingBoxCount,
      tooltip: `${content.vaultingBoxCount} ${
        content.vaultingBoxCount > 1 ? t('MATERIALBLOCK__VAULTING_BOXES') : t('MATERIALBLOCK__VAULTING_BOX')
      }`
    })
  }
  if (content?.longMatCount) {
    data.push({
      icon: 'long-mat',
      label: content.longMatCount,
      tooltip: `${content.longMatCount} ${
        content.longMatCount > 1 ? t('MATERIALBLOCK__LONG_MATS') : t('MATERIALBLOCK__LONG_MAT')
      }`
    })
  }
  if (content?.thickMatCount) {
    data.push({
      icon: 'thick-mat',
      label: content.thickMatCount,
      tooltip: `${content.thickMatCount} ${
        content.thickMatCount > 1 ? t('MATERIALBLOCK__THICK_MATS') : t('MATERIALBLOCK__THICK_MAT')
      }`
    })
  }
  if (content?.thinMatCount) {
    data.push({
      icon: 'thin-mat',
      label: content.thinMatCount,
      tooltip: `${content.thinMatCount} ${
        content.thinMatCount > 1 ? t('MATERIALBLOCK__THIN_MATS') : t('MATERIALBLOCK__THIN_MAT')
      }`
    })
  }
  if (content?.korfballCount) {
    data.push({
      icon: 'korfbal',
      label: content.korfballCount,
      tooltip: `${content.korfballCount} ${
        content.korfballCount > 1 ? t('MATERIALBLOCK__KORFBALLS') : t('MATERIALBLOCK__KORFBALL')
      }`
    })
  }
  if (content?.softballCount) {
    data.push({
      icon: 'soft-bal',
      label: content.softballCount,
      tooltip: `${content.softballCount} ${
        content.softballCount > 1 ? t('MATERIALBLOCK__SOFTBALLS') : t('MATERIALBLOCK__SOFTBALL')
      }`
    })
  }

  // Shirts
  if (content?.shirt1Count || content?.shirt2Count || content?.shirt3Count) {
    const totalShirtsCount = content.shirt1Count + content.shirt2Count + content.shirt3Count
    const icon = theme === 'louis' ? 'lintje' : totalShirtsCount === 1 ? 'shirt' : 'shirts'

    let tooltip = ''

    const shirtLabel = theme === 'louis' ? t('MATERIALBLOCK__LINTJE') : t('MATERIALBLOCK__VEST')
    const shirtLabelPlural = theme === 'louis' ? t('MATERIALBLOCK__LINTJES') : t('MATERIALBLOCK__VESTS')
    if (typeof content.shirt1Count === 'number' && content.shirt1Count !== 0) {
      tooltip = `${content.shirt1Count} ${
        content.shirt1Count === 1
          ? `${
              theme === 'frf' || theme === 'fmf' ? t('MATERIALBLOCK__YELLOW_SINGLE') : t('MATERIALBLOCK__ORANGE_SINGLE')
            } ${shirtLabel}`
          : `${
              theme === 'frf' || theme === 'fmf' ? t('MATERIALBLOCK__YELLOW_PLURAL') : t('MATERIALBLOCK__ORANGE_PLURAL')
            } ${shirtLabelPlural}`
      }`
    }
    if (typeof content.shirt2Count === 'number' && content.shirt2Count !== 0) {
      tooltip += `${content.shirt1Count !== 0 ? ', ' : ''}${content.shirt2Count} ${
        content.shirt2Count === 1
          ? `${
              theme === 'frf' || theme === 'fmf' ? t('MATERIALBLOCK__RED_SINGLE') : t('MATERIALBLOCK__BLUE_SINGLE')
            } ${shirtLabel}`
          : `${
              theme === 'frf' || theme === 'fmf' ? t('MATERIALBLOCK__RED_PLURAL') : t('MATERIALBLOCK__BLUE_PLURAL')
            } ${shirtLabelPlural}`
      }`
    }
    if (typeof content.shirt3Count === 'number' && content.shirt3Count !== 0) {
      tooltip += `${content.shirt1Count !== 0 || content.shirt2Count !== 0 ? ', ' : ''}${content.shirt3Count} ${
        content.shirt3Count === 1
          ? `${
              theme === 'frf' || theme === 'fmf' ? t('MATERIALBLOCK__BLUE_SINGLE') : t('MATERIALBLOCK__YELLOW_SINGLE')
            } ${shirtLabel}`
          : `${
              theme === 'frf' || theme === 'fmf' ? t('MATERIALBLOCK__BLUE_PLURAL') : t('MATERIALBLOCK__YELLOW_PLURAL')
            } ${shirtLabelPlural}`
      }`
    }

    data.push({
      icon: icon,
      label: totalShirtsCount,
      tooltip: tooltip
    })
  }

  // Cones
  if (content?.obstacles1Count || content?.obstacles2Count || content?.obstacles3Count) {
    const totalObstaclesCount = content.obstacles1Count + content.obstacles2Count + content.obstacles3Count
    const icon = totalObstaclesCount === 1 ? 'pawn' : 'pawns'

    let tooltip

    if (typeof content.obstacles1Count === 'number' && content.obstacles1Count !== 0) {
      tooltip = `${content.obstacles1Count} ${
        content.obstacles1Count === 1
          ? `${t('MATERIALBLOCK__YELLOW_SINGLE')} ${t('MATERIALBLOCK__PAWN')}`
          : `${t('MATERIALBLOCK__YELLOW_PLURAL')} ${t('MATERIALBLOCK__PAWNS')}`
      }`
    }
    if (typeof content.obstacles2Count === 'number' && content.obstacles2Count !== 0) {
      const orangePawns = `${content.obstacles1Count !== 0 ? ', ' : ''}${content.obstacles2Count} ${
        content.obstacles2Count === 1
          ? `${t('MATERIALBLOCK__ORANGE_SINGLE')} ${t('MATERIALBLOCK__PAWN')}`
          : `${t('MATERIALBLOCK__ORANGE_PLURAL')} ${t('MATERIALBLOCK__PAWNS')}`
      }`
      tooltip ? (tooltip += orangePawns) : (tooltip = orangePawns)
    }
    if (typeof content.obstacles3Count === 'number' && content.obstacles3Count !== 0) {
      const whitePawns = `${content.obstacles1Count !== 0 || content.obstacles2Count !== 0 ? ', ' : ''}${
        content.obstacles3Count
      } ${
        content.obstacles3Count === 1
          ? `${t('MATERIALBLOCK__WHITE_SINGLE')} ${t('MATERIALBLOCK__PAWN')}`
          : `${t('MATERIALBLOCK__WHITE_PLURAL')} ${t('MATERIALBLOCK__PAWNS')}`
      }`
      tooltip ? (tooltip += whitePawns) : (tooltip = whitePawns)
    }

    data.push({
      icon: icon,
      label: totalObstaclesCount,
      tooltip: tooltip
    })
  }

  return data
}
